import { observer } from 'mobx-react-lite'
import { ContainerHeader, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const DoubleOptInHeader = observer(() => {
  const entities = useEntitiesContext()

  if (entities.featureFlagsStore.quiet_hours) {
    return (
      <ContainerHeader
        customTitle={
          <header className={styles.header}>
            <Typography variant='heading-lg' ariaLabel='Organization header'>
              Organization
            </Typography>
            <Typography
              className={styles.headerDescription}
              variant='body-md-regular'
              ariaLabel='Organization settings description'
            >
              Manage your organization settings
            </Typography>
          </header>
        }
        paddingTop={65}
        paddingBottom={0}
        paddingLeft={0}
        paddingRight={0}
        isAutoHeight={true}
      />
    )
  }

  return (
    <ContainerHeader
      customTitle={
        <header className={styles.header}>
          <Typography variant='heading-lg' ariaLabel='General header'>
            General
          </Typography>
          <Typography
            className={styles.headerDescription}
            variant='body-md-regular'
            ariaLabel='General settings description'
          >
            Edit your workspace details
          </Typography>
        </header>
      }
      paddingTop={65}
      paddingBottom={0}
      paddingLeft={0}
      paddingRight={0}
      isAutoHeight={true}
    />
  )
})
